"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_OWNER = void 0;
exports.ASSET_OWNER = {
    AUTORESPONDER: 'AUTORESPONDER',
    CUSTOMER_ACCOUNT: 'CUSTOMER_ACCOUNT',
    CREW_VARIANT: 'CREW_VARIANT',
    LANDING: 'LANDING',
    LANDING_PRODUCT: 'LANDING_PRODUCT',
    PAGE: 'PAGE',
    PRODUCT: 'PRODUCT',
    PROMOCODE: 'PROMOCODE',
    DTG_PRODUCT: 'DTG_PRODUCT',
    PRODUCT_PRICE: 'PRODUCT_PRICE',
    SETTING: 'SETTING',
    STORE: 'STORE',
    TEMPLATE: 'TEMPLATE',
    TSHIRT_VARIANT: 'TSHIRT_VARIANT',
    QUIZ_QUESTION: 'QUIZ_QUESTION',
    QUIZ_RESULT: 'QUIZ_RESULT',
    PRODUCT_VARIANT_VALUE: 'PRODUCT_VARIANT_VALUE',
    ORDER_ITEM: 'ORDER_ITEM',
    ORDER_ITEM_ARTWORK: 'ORDER_ITEM_ARTWORK',
    ORDER_ITEM_ARTWORK_BACK: 'ORDER_ITEM_ARTWORK_BACK'
};
//# sourceMappingURL=assetOwner.js.map